<div class="table-header">
  <span>Communities</span>
  <div class="position-relative table-icon action">
    <i class="fa fa-list transition text-tooltip" aria-hidden="true" title-popup="List"></i>
    <div class="tooltip-actions width-120">
      <div class="arrow-up"></div>
      <ul>
        <li>
          <label col-id="0" table-name="roaming-communities-list" class="checked">Name</label>
        </li>
        <li>
          <label col-id="1" table-name="roaming-communities-list" class="checked">Protocol Version</label>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="isAdmin" class="table-icon plus">
    <i [routerLink]="['/create-roaming-communities']" class="fa fa-plus transition text-tooltip" aria-hidden="true" title-popup="Add"></i>
  </div>
</div>
<table class="table table-striped" id="roaming-communities-list">
  <thead>
    <tr>
      <th>Name</th>
      <th>Protocol Version</th>
      <th *ngIf="isAdmin"></th>
    </tr>
  </thead>
  <tbody>
  <tr *ngFor="let item of list | paginate: configPagerGetAllRoamingCommunities">
    <td *ngIf="isAdmin"><a [routerLink]="['/roaming-community',item.virtId]">{{item.name}}</a></td>
    <td *ngIf="!isAdmin">{{item.name}}</td>
    <td>{{item.protocolVersion}}</td>
    <td *ngIf="isAdmin">
      <ng-template #actionsPopup>
        <p class="popup-text" (click)="deleteModal.show()">Delete</p>
      </ng-template>
      <button class="view-detail-btn"
              [popover]="actionsPopup"
              placement="left"
              triggers="click"
              [outsideClick]="true"
              container="body">...</button>
        <app-delete-modal #deleteModal
                          text = "Community {{item.name}}  will be deleted."
                          server="{{item.virtId}}"
                          deleteType="roamingCommunity"></app-delete-modal>
    </td>
  </tr>
  </tbody>
</table>

<app-pagination-custom [config]="configPagerGetAllRoamingCommunities"></app-pagination-custom>
